import { useLayoutContext } from "@context/layout";
import IconlyFilledCategoryIcon from "@svg/new-design/bottom-tab-navigation/CategoryIconFilled";
import { ProgramCategory } from "@types";
import classNames from "classnames";
import { FC } from "react";
import { programLabelFormatter } from "./MobileNavigator";
import ProgramSubscriptiuonBanner from "./ProgramSubscriptionBanner";

interface Props {
  categories: ProgramCategory[];
  activeIndex: number;
  // eslint-disable-next-line no-unused-vars
  clickHandler: (categoryId: number) => void;
}

const ProgramPageSidebar: FC<Props> = ({
  categories,
  activeIndex,
  clickHandler,
}) => {
  const { isAdmin } = useLayoutContext();

  const navigationHandler = (categoryId: number) => {
    const theEl = document.getElementById(`${categoryId}-programs`);
    clickHandler(categoryId);
    if (theEl)
      theEl.scrollIntoView({
        behavior: "smooth",
      });
  };

  return (
    <aside
      className="mt-2.5 sticky"
      style={{
        top: `${isAdmin ? 124 : 68}px`,
      }}
    >
      <div className="p-5  rounded-12 bg-fds-primary border border-fds-cart">
        <div className="flex gap-2  items-center">
          <IconlyFilledCategoryIcon
            width={16}
            height={16}
            className="text-fds-icon-secondary"
          />
          <p className="title-lg text-fds-primary">انتخاب دسته‌بندی یا گرایش</p>
        </div>
        <div className="w-full bg-fds-disable h-0.5 my-4" />
        <nav className="flex flex-col gap-4">
          {categories.map((category, i) => {
            const isActive = i === activeIndex;
            return (
              <div key={i}>
                <p
                  onClick={() => navigationHandler(category.id)}
                  className={classNames(
                    "title-md-demibold",
                    isActive
                      ? "text-fds-brand cursor-auto"
                      : "text-fds-primary cursor-pointer"
                  )}
                >
                  {programLabelFormatter(category.name)}
                </p>
              </div>
            );
          })}
        </nav>
      </div>
      <div className="mt-4 pb-2">
        <ProgramSubscriptiuonBanner />
      </div>
    </aside>
  );
};

export default ProgramPageSidebar;
